import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col, Button, Alert } from 'react-bootstrap';
import NotesAndAssumptionsTableEnhanced from './NotesAndAssumptionsTableEnhanced';
const NotesAndAssumptionsList = _ref => {
  let {
    notes = [],
    categories = [],
    onUpdate,
    onDelete,
    userCanEdit,
    onReviewUpdate,
    loading,
    claimId,
    fetchNotes,
    onSendReviewerEmail,
    onSendResponseEmail,
    emailLoading,
    user
  } = _ref;
  const {
    t
  } = useTranslation();
  const hasActiveReview = notes.some(note => note.has_active_cost_review);
  const activeNote = notes.find(n => n.has_active_cost_review && n.current_review);
  const changeSet = activeNote?.current_review?.change_set;
  const isReviewer = changeSet && user.id === changeSet.assigned_to_id;
  const isConsultant = changeSet && user.id === changeSet.author_id;
  const pendingClarificationCount = useMemo(() => {
    if (!isReviewer || !hasActiveReview) return 0;
    return notes.filter(note => {
      const review = note.current_review;
      if (!review) return false;
      const isRelevantStatus = ['closed', 'clarification_required'].includes(review.status);
      const notSent = !review.clarification_email_sent_at;
      return isRelevantStatus && notSent;
    }).length;
  }, [notes, isReviewer, hasActiveReview]);
  const pendingResponseCount = useMemo(() => {
    if (!isConsultant || !hasActiveReview) return 0;
    return notes.reduce((count, note) => {
      if (!note.active_reviews) return count;
      const respondedCount = note.active_reviews.filter(review => {
        const hasResponded = review.responded_at !== null;
        const notSent = !review.response_email_sent_at;
        return hasResponded && notSent;
      }).length;
      return count + respondedCount;
    }, 0);
  }, [notes, isConsultant, hasActiveReview]);
  if (notes.length === 0) {
    return /*#__PURE__*/React.createElement("p", {
      className: "text-muted text-center py-4"
    }, t('no_notes_match_search'));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, hasActiveReview && (isReviewer || isConsultant) && /*#__PURE__*/React.createElement(Alert, {
    variant: "info",
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Row, {
    className: "align-items-center"
  }, /*#__PURE__*/React.createElement(Col, null, isReviewer && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, "Reviewer Actions:"), /*#__PURE__*/React.createElement("p", {
    className: "mb-2 mt-1"
  }, pendingClarificationCount > 0 ? `${pendingClarificationCount} clarification${pendingClarificationCount > 1 ? 's' : ''} pending` : 'No pending clarifications to send'), /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    size: "sm",
    onClick: onSendReviewerEmail,
    disabled: pendingClarificationCount === 0 || emailLoading
  }, emailLoading ? 'Sending...' : `Send Email to Consultant`)), isConsultant && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, "Consultant Actions:"), /*#__PURE__*/React.createElement("p", {
    className: "mb-2 mt-1"
  }, pendingResponseCount > 0 ? `${pendingResponseCount} response${pendingResponseCount > 1 ? 's' : ''} pending` : 'No pending responses to send'), /*#__PURE__*/React.createElement(Button, {
    variant: "success",
    size: "sm",
    onClick: onSendResponseEmail,
    disabled: pendingResponseCount === 0 || emailLoading
  }, emailLoading ? 'Sending...' : `Send Email to Reviewer`))))), /*#__PURE__*/React.createElement(NotesAndAssumptionsTableEnhanced, {
    notes: notes,
    categories: categories,
    onUpdate: onUpdate,
    onDelete: onDelete,
    userCanEdit: userCanEdit,
    onReviewUpdate: onReviewUpdate,
    loading: loading,
    claimId: claimId,
    fetchNotes: fetchNotes
  }));
};
export default NotesAndAssumptionsList;